import { Product } from "../models/ticket";

export const calculateTotalValue = (listProducts: Product[]) =>
  listProducts.reduce((acc, current) => {
    return acc + current.price * current.quantity;
  }, 0);
